(function () {
  "use strict";
  var doc = document;
  var ROOT = "[data-xg-ingx]";
  var COLUMN = "(min-width: 1000px)";
  var reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function norm(s) {
    s = String(s || "").toLowerCase();
    if (String.prototype.normalize) {
      s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    return s.replace(/\s+/g, " ").replace(/[^a-z0-9 ]+/g, "").trim();
  }
  function tokens(q) {
    var t = norm(q);
    return t ? t.split(" ") : [];
  }
  function matches(hay, list) {
    for (var i = 0; i < list.length; i += 1) {
      if (hay.indexOf(list[i]) === -1) return false;
    }
    return true;
  }
  function build(scope) {
    var form = scope.querySelector("[data-xg-ingx-form]");
    var input = scope.querySelector("[data-xg-ingx-input]");
    var clear = scope.querySelector("[data-xg-ingx-clear]");
    var count = scope.querySelector("[data-xg-ingx-count]");
    var empty = scope.querySelector("[data-xg-ingx-empty]");
    var expand = scope.querySelector("[data-xg-ingx-expand]");
    var nav = scope.querySelector("[data-xg-ingx-nav]");
    var pos = scope.querySelector("[data-xg-ingx-pos]");
    var track = scope.querySelector("[data-xg-ingx-panels]");
    var panels = [].slice.call(scope.querySelectorAll("[data-xg-ingx-panel]"));
    var chips = [].slice.call(scope.querySelectorAll("[data-xg-ingx-jump]"));
    if (!input || !track || !panels.length) return;
    var mq = typeof window.matchMedia === "function" ? window.matchMedia(COLUMN) : null;
    var byPanel = panels.map(function (panel) {
      var rows = [].slice.call(panel.querySelectorAll("[data-xg-ingx-row]"));
      return {
        el: panel,
        id: panel.getAttribute("data-xg-ingx-panel") || "",
        rows: rows,
        hay: rows.map(function (row) { return norm(row.textContent); }),
        ids: rows.map(function (row) { return row.getAttribute("data-xg-ingx-id") || ""; }),
        folds: rows.map(function (row) { return row.querySelector("details"); }),
        shown: rows.length
      };
    });
    var chipFor = {};
    for (var c = 0; c < chips.length; c += 1) {
      chipFor[chips[c].getAttribute("data-xg-ingx-jump") || ""] = chips[c];
    }
    var total = parseInt((count && count.getAttribute("data-xg-ingx-total")) || "0", 10);
    var noun = (count && count.getAttribute("data-xg-ingx-noun")) || "results";
    var current = 0;
    var lastQuery = null;
    var query = [];
    function column() {
      return !!(mq && mq.matches);
    }
    function visiblePanels() {
      return byPanel.filter(function (p) { return !p.el.hasAttribute("hidden"); });
    }
    function paint() {
      var col = column();
      for (var i = 0; i < byPanel.length; i += 1) {
        var p = byPanel[i];
        var chip = chipFor[p.id];
        if (chip) {
          if (i === current) chip.setAttribute("aria-current", "true");
          else chip.removeAttribute("aria-current");
        }
        var show = p.shown > 0 && (!col || i === current);
        if (show) p.el.removeAttribute("hidden");
        else p.el.setAttribute("hidden", "");
      }
      var vis = visiblePanels();
      if (pos) {
        var at = vis.indexOf(byPanel[current]);
        pos.textContent = (at < 0 ? 0 : at + 1) + " / " + vis.length;
        if (col || vis.length < 2) pos.setAttribute("hidden", "");
        else pos.removeAttribute("hidden");
      }
      railTo(chipFor[byPanel[current].id]);
      fitHeight();
      syncExpand();
    }
    function railTo(chip) {
      if (!chip || column()) return;
      var rail = chip.closest("[data-xg-scroll-track]");
      if (!rail || rail.scrollWidth <= rail.clientWidth + 1) return;
      var left = chip.offsetLeft - (rail.clientWidth - chip.offsetWidth) / 2;
      rail.scrollTo({ left: left, behavior: reduced ? "instant" : "smooth" });
    }
    function fitHeight() {
      if (column()) {
        track.style.blockSize = "";
        return;
      }
      var p = byPanel[current];
      var h = p && !p.el.hasAttribute("hidden") ? p.el.offsetHeight : 0;
      if (!h) {
        track.style.blockSize = "";
        return;
      }
      var cs = window.getComputedStyle(track);
      var pad = (parseFloat(cs.paddingBlockStart) || 0) + (parseFloat(cs.paddingBlockEnd) || 0);
      track.style.blockSize = h + pad + "px";
    }
    var lock = -1;
    var lockTimer = 0;
    function fromScroll() {
      if (column()) return;
      var vis = visiblePanels();
      if (!vis.length) return;
      var left = track.scrollLeft;
      var best = 0;
      var bestD = Infinity;
      var first = vis[0].el.offsetLeft;
      for (var i = 0; i < vis.length; i += 1) {
        var d = Math.abs(vis[i].el.offsetLeft - first - left);
        if (d < bestD) { bestD = d; best = i; }
      }
      var idx = byPanel.indexOf(vis[best]);
      if (lock >= 0) {
        if (idx !== lock) return;
        lock = -1;
        window.clearTimeout(lockTimer);
      }
      if (idx !== current) {
        current = idx;
        paint();
      }
    }
    function scrollToPanel(p, smooth) {
      var vis = visiblePanels();
      if (!vis.length || vis.indexOf(p) < 0) return;
      var first = vis[0].el.offsetLeft;
      lock = byPanel.indexOf(p);
      window.clearTimeout(lockTimer);
      lockTimer = window.setTimeout(function () { lock = -1; }, 1200);
      track.scrollTo({
        left: p.el.offsetLeft - first,
        behavior: smooth && !reduced ? "smooth" : "instant"
      });
    }
    function select(i, focus, smooth) {
      if (i < 0 || i >= byPanel.length) return;
      current = i;
      paint();
      if (!column()) scrollToPanel(byPanel[i], smooth);
      if (focus) byPanel[i].el.focus({ preventScroll: !column() });
    }
    function apply() {
      var q = input.value;
      var key = q;
      if (key === lastQuery) return;
      lastQuery = key;
      query = tokens(q);
      var distinct = {};
      var shownTotal = 0;
      for (var i = 0; i < byPanel.length; i += 1) {
        var p = byPanel[i];
        var shown = 0;
        for (var r = 0; r < p.rows.length; r += 1) {
          var ok = !query.length || matches(p.hay[r], query);
          if (ok) {
            shown += 1;
            distinct[p.ids[r]] = true;
            p.rows[r].removeAttribute("hidden");
          } else {
            p.rows[r].setAttribute("hidden", "");
          }
          var d = p.folds[r];
          if (d) {
            if (ok && query.length && !d.open) {
              d.open = true;
              d.setAttribute("data-xg-ingx-auto", "");
            } else if ((!ok || !query.length) && d.hasAttribute("data-xg-ingx-auto")) {
              d.open = false;
              d.removeAttribute("data-xg-ingx-auto");
            }
          }
        }
        p.shown = shown;
        shownTotal += shown;
        var chip = chipFor[p.id];
        if (chip) {
          var n = chip.querySelector(".xg-ingx__chip-n");
          if (n) n.textContent = String(shown);
          if (query.length) chip.setAttribute("data-xg-ingx-hits", String(shown));
          else chip.removeAttribute("data-xg-ingx-hits");
        }
        if (shown) p.el.removeAttribute("hidden");
        else p.el.setAttribute("hidden", "");
      }
      var names = Object.keys(distinct).length;
      if (clear) {
        if (q) clear.removeAttribute("hidden");
        else clear.setAttribute("hidden", "");
      }
      if (empty) {
        if (shownTotal) empty.setAttribute("hidden", "");
        else empty.removeAttribute("hidden");
      }
      if (count) {
        count.textContent = !q
          ? total + " " + noun + "."
          : names + " of " + total + " " + noun + ".";
      }
      if (shownTotal && !byPanel[current].shown) {
        for (var j = 0; j < byPanel.length; j += 1) {
          if (byPanel[j].shown) { current = j; break; }
        }
        paint();
        if (!column()) scrollToPanel(byPanel[current], true);
        return;
      }
      paint();
    }
    function shownFolds() {
      var p = byPanel[current];
      var out = [];
      if (!p) return out;
      for (var i = 0; i < p.rows.length; i += 1) {
        if (p.folds[i] && !p.rows[i].hasAttribute("hidden")) out.push(p.folds[i]);
      }
      return out;
    }
    function syncExpand() {
      if (!expand) return;
      var vis = shownFolds();
      var allOpen = vis.length > 0;
      for (var i = 0; i < vis.length; i += 1) {
        if (!vis[i].open) { allOpen = false; break; }
      }
      expand.textContent = expand.getAttribute(allOpen ? "data-xg-ingx-collapse-label" : "data-xg-ingx-expand-label") || "";
      expand.setAttribute("aria-pressed", allOpen ? "true" : "false");
      if (vis.length) expand.removeAttribute("hidden");
      else expand.setAttribute("hidden", "");
    }
    input.addEventListener("input", apply);
    input.addEventListener("search", apply);
    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        apply();
        var p = byPanel[current];
        if (p && !p.el.hasAttribute("hidden")) p.el.focus({ preventScroll: !column() });
      });
    }
    if (clear) {
      clear.addEventListener("click", function () {
        input.value = "";
        apply();
        input.focus();
      });
    }
    if (expand) {
      expand.addEventListener("click", function () {
        var vis = shownFolds();
        var open = expand.getAttribute("aria-pressed") !== "true";
        for (var i = 0; i < vis.length; i += 1) {
          vis[i].open = open;
          vis[i].removeAttribute("data-xg-ingx-auto");
        }
        syncExpand();
      });
    }
    scope.addEventListener("toggle", function (event) {
      if (event.target && event.target.matches("[data-xg-ingx-row] details")) {
        syncExpand();
        fitHeight();
      }
    }, true);
    for (var k = 0; k < chips.length; k += 1) {
      chips[k].addEventListener("click", function (event) {
        var id = this.getAttribute("data-xg-ingx-jump") || "";
        var idx = -1;
        for (var i = 0; i < byPanel.length; i += 1) {
          if (byPanel[i].id === id) { idx = i; break; }
        }
        if (idx < 0) return;
        event.preventDefault();
        select(idx, true, true);
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, "", "#" + byPanel[idx].el.id);
        }
      });
    }
    var queued = false;
    track.addEventListener("scroll", function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        fromScroll();
      });
    }, { passive: true });
    if (typeof window.ResizeObserver === "function") {
      var ro = new window.ResizeObserver(function () { fitHeight(); });
      for (var m = 0; m < panels.length; m += 1) ro.observe(panels[m]);
    }
    if (mq) {
      var onMode = function () { select(current, false, false); };
      if (mq.addEventListener) mq.addEventListener("change", onMode);
      else if (mq.addListener) mq.addListener(onMode);
    }
    if (expand) expand.removeAttribute("hidden");
    if (nav && pos) pos.removeAttribute("hidden");
    var start = 0;
    var hash = (window.location.hash || "").replace(/^#/, "");
    for (var s = 0; s < byPanel.length; s += 1) {
      if (byPanel[s].el.id === hash) { start = s; break; }
    }
    current = start;
    if (input.value) apply();
    else paint();
    if (start && !column()) scrollToPanel(byPanel[start], false);
  }
  function init(scope) {
    var roots = (scope || doc).querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i += 1) {
      if (roots[i].hasAttribute("data-xg-ingx-ready")) continue;
      roots[i].setAttribute("data-xg-ingx-ready", "");
      build(roots[i]);
    }
  }
  init(doc);
  doc.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  window.XG = window.XG || {};
  window.XG.ingredients = { init: init };
})();
